import { render, staticRenderFns } from "./VentasMercadoPagoNoIngresadasItem.vue?vue&type=template&id=e06d0fe6&"
import script from "./VentasMercadoPagoNoIngresadasItem.vue?vue&type=script&lang=js&"
export * from "./VentasMercadoPagoNoIngresadasItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports